import {
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensors,
  useSensor
} from "@dnd-kit/core";
import {
  sortableKeyboardCoordinates
} from "@dnd-kit/sortable";

export const useDndKitSensors = () => {

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    }),
  );

  return sensors
};